<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="ll-calendar__contextmenu-layer"
      @click.self="emit('close')"
      @contextmenu.prevent
    >
      <div
        ref="boundaryRef"
        class="ll-calendar__boundary-proxy"
        :style="boundaryStyle"
        aria-hidden="true"
      >
        <div
          ref="menuRef"
          :class="[`ll-calendar__contextmenu`, `ll-calendar__teleport-layer`]"
          :style="style"
          @click.stop
        >
          <slot
            name="event-contextmenu"
            :event="event"
            :close="closeMenu"
            :edit="() => emit('edit')"
            :copy="() => emit('copy')"
            :remove="() => emit('remove')"
          >
            <div class="ll-calendar__contextmenu-actions">
              <ll-button size="small" @click="emit('edit')">编辑</ll-button>
              <ll-button size="small" @click="emit('copy')">复制</ll-button>
              <ll-button
                :disabled="!canDelete"
                size="small"
                danger
                @click="emit('remove')"
              >
                删除
              </ll-button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import type { CalendarEvent } from './calendar'

const props = defineProps({
  open: { type: Boolean, required: true },
  style: { type: Object, required: true },
  event: { required: true },
  currentEditableEvent: { type: Object, required: true },
  boundaryStyle: { type: Object, required: false }
})

const emit = defineEmits(["close", "edit", "copy", "remove"])

const menuRef = useTemplateRef('menuRef')
const canDelete = computed(() => props.currentEditableEvent.delete !== false)

const closeMenu = () => {
  emit('close')
}

defineExpose({
  menuRef,
})
</script>
